module.exports = __webpack_public_path__ + "img/FAV_0053.52900d37.jpg";